import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Game} from "../Game";

export class ZeroBetIdlePresentation implements FlowStatePresentation {

    public start(flowStateController: FlowStateController): void {
        Game.apiPlugin.betHandler.zeroBet();

        // #151
        if (Game.model.data.nextMode === "FREESPIN") {
            Game.keypadPlugin.setZeroBetSpinCounter(Math.max(Game.model.data.freespinsLeft - 1, 0));
        }

        if (Game.model.isRestore) {
            if (Game.model.data.mode.indexOf("FREESPIN") !== -1 || Game.model.data.nextMode.indexOf("FREESPIN") !== -1) { // #255
                Game.scatterInventory.hideSMeter();
            }
        } else if (Game.model.gameData.mode.indexOf("NORMAL") !== -1 && Game.model.gameData.nextMode === 'FREESPIN') {
            Game.keypadPlugin.setWin(Game.model.data.accumulatedRoundWin, true, Game.isWinBelowStake());
        }

        flowStateController.finish();
    }
}